<template>
  <v-textarea
    v-model="model"
    :label="fieldLabel"
    solo
    :rules="textareaRules"
    rounded
    prepend-inner-icon
    required
    outlined
    dense
  ></v-textarea>
</template>

<script>
// import { textareaRules } from '@/lib/rules.js';
import { t } from '@/store/modules/homeDrushim/constantsContent';
export default {
  props: {
    fieldLabel: {
      type: String,
    },
  },

  data() {
    return {
      model: '',
      textareaRules: [
        (v) => !!v || t('titles.requiredField'),
        (v) =>
          /^[^#%^&*()"{}|<>]+$/.test(v) || 'תוכן לא תקין , מחק תווים מיוחדים',
      ],
    };
  },
  methods: {
    postReply() {
      return false;
    },
  },

  computed: {},

  watch: {
    model() {
      this.$emit('child-field', this.model);
    },
  },
};
</script>